import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PulseLoader } from 'halogenium';
import AddNewMembershipModal from './AddNewMembershipModal';
import './SelectMembershipModal.scss';
import MembershipTable from '../../app/Merchant/Membership/MembershipTable';

var portalRoot = null;

class SelectMembershipModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#select-membership-modal').length == 0) {
            $('body').prepend('<div id="select-membership-modal" style="position:absolute; z-index:1501"></div>')
        }
        portalRoot = document.getElementById("select-membership-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class SelectMembershipModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            memberships: [],
        }
        this.modalId = "select-membership-bs-modal"
        this.callbackKey = "SelectMembershipModal"

        this.membershipTableRef = React.createRef()
    }
    initVariationTemplate = () => {
        let vt = {...(this.props.variationTemplate || {})}
        this.booleanConvert(vt)
        return vt
    }
    // Convert all true/false properties to 1/0
    booleanConvert = (obj) => {
        Object.keys(obj).forEach(key => {
            if (obj[key] === true) {
                obj[key] = 1
            }
            else if (obj[key] === false) {
                obj[key] = 0
            }
        })
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.reloadData()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.onCancelClicked()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

        if (this.props.autoShow && this.modalId) {
            $('#'+this.modalId)
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => {
                if (this.isSkipModalListener) {
                    return
                }

                this.props.onModalClosed && this.props.onModalClosed()

                // https://stackoverflow.com/a/24914782
                // Fix double bootstrap modal issue where after the top most modal is closed,
                // the remaining modal unable to scroll
                $('.modal:visible').length && $(document.body).addClass('modal-open')
            })
            .modal();
        }

        $(document).on('show.bs.modal', '.modal', function() {
            const zIndex = 1040 + 10 * $('.modal:visible').length;
            $(this).css('z-index', zIndex);
            setTimeout(() => $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack'));
        });

        // We can tap the modal before close event to "cancel" closing of
        // the modal
        $('#'+ this.modalId)
            .on('hide.bs.modal', () => {
                if (this.isSkipModalListener) {
                    return true
                }
                return this.attemptCloseModal()
            })
    }

    attemptCloseModal = () => {
        if (!this.checkAllowCloseModal(this.forceClose)) {
            return false
        }
        this.props.onNo && this.props.onNo()
        return true
    }
    forceClose = () => {
        this.close(true)
    }
    // Parent to call this to dismiss the modal
    close = (forceClose) => {
        if (forceClose) {
            this.removeOnHideListener()
        }
        $('#'+this.modalId).modal('hide')
    }
    onYes = () => {
        if (this.state.selectedMembership) {
            this.props.onYes && this.props.onYes(this.state.selectedMembership)
        }
    }
    onAddNewMembership = () => {

        // Turn OFF listener (listener may trigger to close the modal),
        // and temporarily hide the modal, before showing the second modal
        this.isSkipModalListener = true
        $('#'+this.modalId).modal('hide');

        if (!this.newMembershipModalRef) {
            this.newMembershipModalRef = React.createRef()
        }
        setTimeout(() => {
            const onClose = () => {
                this.newMembershipModalRef && this.newMembershipModalRef.current && this.newMembershipModalRef.current.close(true)
                setTimeout(() => {
                    this.setState({
                        newMembershipModal: null,
                    }, () => {
                        // We are done with the second modal, show back
                        // the original modal that was hidden temporarily
                        this.isSkipModalListener = false
                        $('#'+this.modalId).modal('show');

                        // Fix unable to scroll
                        $('.modal:visible').length && $(document.body).addClass('modal-open')
                    })    
                }, 200);
            }
            this.setState({
                newMembershipModal: <AddNewMembershipModal
                    app={this.props.app}
                    ref={this.newMembershipModalRef}
                    // variationTemplate={variationTemplateToEdit}
                    autoShow={true}
                    onModalClosed={onClose}
                    onNo={onClose}
                    onYes={(membership) => {
                        this.selectMembership(membership)
                        this.membershipTableRef.current && this.membershipTableRef.current.selectMembership(membership)
                        onClose()
                    }}
                />
            })
        }, 200);
    }

    onCancelClicked = () => {
        $('#'+this.modalId).modal('hide')
    }
    getButtons = () => {
        const disabled = !this.state.selectedMembership || !this.state.selectedMembership.id
        return (
            <div style={{display: "flex"}}>
                <div style={{flex: "0 0 100px", textAlign: "left"}}>
                    <button onClick={this.onAddNewMembership} className="btn btn-primary btn-sm">{lang.add_new}</button>
                </div>
                <div style={{flex: "1 0 100px", textAlign: "right"}}>
                    <button onClick={this.onCancelClicked} className="btn btn-danger btn-sm mr-2">{this.props.noText || lang.cancel}</button>
                    <button disabled={disabled} onClick={this.onYes} className="btn btn-success btn-sm">{this.props.yesText || lang.confirm}</button>
                </div>
            </div>
        )
    }
    removeOnHideListener = () => {
        $('#'+ this.modalId)
            .off('hide.bs.modal')
    }
    checkAllowCloseModal = (closeModal) => {
        if (this.state.isEdited) {
            if (confirm(lang.changes_not_saved_sure_to_close)) {
                if (closeModal) {
                    setTimeout(closeModal, 200)
                }
            }
            return false
        }
        return true
    }
    onClose = () => {
        this.props.onClose && this.props.onClose()
    }
    onChange = (e) => {
        this.setState({
            selectedMemership: {
                ...this.state.variationTemplate,
                [e.target.name]: e.target.value,
            },
            isEdited: true,
        })
    }
    selectMembership = (selectedMembership) => {
        this.setState({
            selectedMembership: selectedMembership,
        })
    }
    onSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    reloadData = () => {
        this.membershipTableRef.current && this.membershipTableRef.current.reloadMembershipList()
    }
    render() {
        return (
            <>
                {this.state.newMembershipModal}
                <SelectMembershipModalPortal>
                    <div id={this.modalId} style={{zIndex:"1500"}} className="modal fade" role="dialog">
                        <div className={`modal-dialog ${this.props.modalSize || "modal-lg"}`}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="modal-two-title">{this.props.title || ""}</h4>
                                </div>
                                <div className="modal-body container-fluid">
                                    <div className="mb-2">
                                        {
                                            this.state.isSaving ?
                                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                                            this.getButtons()
                                        }
                                    </div>
                                    <div className="mb-2">
                                        <div style={{display: "flex"}}>
                                            <div style={{flex: "1 0 100px"}} className="input-with-icon mb-2">
                                                <input type="text" placeholder={lang.search_membership_placeholder} onChange={this.onSearchTextChange} value={this.state.searchText || ""} className="form-control" />
                                                <span className="fa fa-search input-icon"></span>
                                            </div>
                                            <div>
                                                <button type="button" className="btn btn-sm btn-primary" onClick={this.reloadData}><i className="fa fa-refresh"/></button>
                                            </div>
                                        </div>
                                        <MembershipTable searchText={this.state.searchText} ref={this.membershipTableRef} selectMembership={this.selectMembership}/>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    {
                                        this.state.isSaving ?
                                        <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                                        this.getButtons()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </SelectMembershipModalPortal>
            </>
        )
    }
}
SelectMembershipModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
}
export default SelectMembershipModal;